import { render, staticRenderFns } from "./TriggerCampaignCreate.vue?vue&type=template&id=3ad74f06"
import script from "./TriggerCampaignCreate.vue?vue&type=script&lang=js"
export * from "./TriggerCampaignCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports